import { AbstractDonorDataService } from "./AbstractDonorDataService";
import {IDonorDTO, IDonorSex, IExternalDonorDTO} from "../../../types/IDonorDTO";
import {
   IDonorAppointmentDTO,
   IDonorContactPreference,
   IDonorDataService,
   IDonorDonationDTO,
   IDonorEligibilityDate,
   IDonorIdEmailVerificationRequest,
   IDonorQRCodeInterface,
   IDonorValidationRequest,
} from "./IDonorDataService";

export class DonorDataService
   extends AbstractDonorDataService
   implements IDonorDataService
{
   public getDonor(donorId: string): Promise<IDonorDTO> {
      return this.getBex<IDonorDTO>(`donors/${donorId}`);
   }

   public getExternalDonor(externalDonorId: string): Promise<IExternalDonorDTO> {
      return this.getBex<IExternalDonorDTO>(`externaldonors/${externalDonorId}`);
   }

   public validateDonor(
      validationRequest: IDonorValidationRequest,
      // SCREDP-112 - Prevent multiple submissions while save request operations are executing
      startLoading?,
      stopLoading?
   ): Promise<string> {
      return this.postBex<IDonorValidationRequest, string>(
         "donors/validate",
         validationRequest,
         // SCREDP-112 - Prevent multiple submissions while save request operations are executing
         startLoading,
         stopLoading
      );
   }

   public getDonorAppointment(
      donorId: string,
      appointmentId: string,
   ): Promise<IDonorAppointmentDTO> {
      return this.getBex<IDonorAppointmentDTO>(
         `donors/${donorId}/appointments/${appointmentId}`,
      );
   }

   public getDonorContactPreferences(
      donorId: string,
   ): Promise<IDonorContactPreference[]> {
      return this.getBex<IDonorContactPreference[]>(
         `donors/${donorId}/contactPreferences`,
      );
   }

   public setDonorContactPreferences(
      donorId: string,
      preferences: IDonorContactPreference[],
      // SCREDP-112 - Prevent multiple submissions while save request operations are executing
      startLoading?,
      stopLoading?
   ): Promise<void> {
      return this.postBex<IDonorContactPreference[], any>(
         `donors/${donorId}/contactPreferences`,
         preferences,
         // SCREDP-112 - Prevent multiple submissions while save request operations are executing
         startLoading,
         stopLoading
      );
   }

   public getDonorDonations(donorId: string): Promise<IDonorDonationDTO[]> {
      return this.getBex<IDonorDonationDTO[]>(`donors/${donorId}/donations`);
   }

   public getDonorEligibilityDates(
      donorId: string,
   ): Promise<IDonorEligibilityDate[]> {
      return this.getBex<IDonorEligibilityDate[]>(
         `donors/${donorId}/eligibilityDates`,
      );
   }

   public getDonorIdCard(
      donorId: string,
      qrcodeParameters: IDonorQRCodeInterface,
   ): Promise<Blob> {
      return this.getBlobBex(
         `donors/${donorId}/getDonorIDBarcode?height=${qrcodeParameters.height}&width=${qrcodeParameters.width}&barcodeType=${qrcodeParameters.type}`,
      );
   }

   public getDonorAppointments(
      donorId: string,
   ): Promise<IDonorAppointmentDTO[]> {
      return this.getBex<IDonorAppointmentDTO[]>(
         `donors/${donorId}/appointments`,
      );
   }


   public getSexOptions(): Promise<IDonorSex[]> { // SCREDP-108: get sex options from API
      return this.getBex<IDonorSex[]>(`donors/getSexOptions`);
   }

   // SCREDP-68: verify donor ID for email when unconfirmed donor signs in
   public verifyDonorIdForEmail(verificationRequest: IDonorIdEmailVerificationRequest): Promise<boolean> {
      return this.postBex<IDonorIdEmailVerificationRequest, boolean>(
         "donors/verify-donor-id-for-email",
         verificationRequest, null, null
      );
   }
}
